<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Visiting",
};
</script>

<style lang="scss" scoped></style>
